<template>
  <div class="row preview-container" :style="cssBackgroundVars">
    <div class="col-6 preview-text-1" v-if="configurations.templateType === configType.onlyText">
      {{ renderData() }}
    </div>
    <div class="col-6 sign-container sign-design"
         v-if="configurations.templateType === configType.desing">
      <div class="signature-font">
        {{ configurations.emulation }}
      </div>
    </div>
    <div class="col-6 sign-container" v-if="configurations.templateType === configType.draw">
      <img :src="signatureImage" class="sign-image">
    </div>
    <div class="col-6 sign-container" v-if="configurations.templateType === configType.atached">
      <img :src="signatureImage" class="sign-image">
    </div>
    <div class="col-6 preview-text-2" v-if="configurations.templateType !== configType.onlyText">
      {{ renderData() }}
    </div>
  </div>
</template>

<script>
import { configType } from '@/febos/global/usuario/components/sign/simple/febos/constants';
import { capitalize, passToUrl } from '@/febos/global/utils/configurations';

export default {
  name: 'SignaturePreview',
  data() {
    return {
      configType
    };
  },
  computed: {
    cssBackgroundVars() {
      let url = '';
      if (this.configurations && this.configurations.background) {
        url = passToUrl(this.configurations.background);
      }
      return {
        'overflow-y': 'hidden',
        'background-image': `url(${url})`
      };
    },
    signatureImage() {
      if (this.configurations && this.configurations.respresentation) {
        if (this.configurations.respresentation.startsWith('data:image')) {
          return this.configurations.respresentation;
        }
        return passToUrl(this.configurations.respresentation);
      }
      return '';
    }
  },
  methods: {
    renderData() {
      let linea = this.configurations.textTemplate;
      if (typeof linea === 'undefined') return '';
      linea = linea.replace('{usuario.id}', this.user.id);
      linea = linea.replace('{usuario.iut}', this.user.iut);
      linea = linea.replace('{usuario.nombre}', capitalize(this.user.nombre));
      linea = linea.replace('{usuario.alias}', capitalize(this.user.alias));
      linea = linea.replace(
        '{usuario.cargo}',
        capitalize(this.user.cargo || 'Cargo no configurado')
      );
      linea = linea.replace(
        '{usuario.departamento}',
        capitalize(this.user.departamento || 'Departamento no configurado')
      );
      linea = linea.replace('{empresa.id}', this.company.id);
      linea = linea.replace('{empresa.iut}', this.company.iut);
      linea = linea.replace('{empresa.razonSocial}', capitalize(this.company.razonSocial));
      linea = linea.replace('{empresa.fantasia}', capitalize(this.company.fantasia));

      const meses = [
        '',
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ];
      const ahora = new Date();
      const fechaHoraCompleta = `${ahora.getDate() < 10 ? `0${ahora.getDate()}` : ahora.getDate()
      } de ${
        meses[ahora.getMonth()]
      } del ${
        ahora.getFullYear()
      } a las ${
        ahora.getHours() < 10 ? `0${ahora.getHours()}` : ahora.getHours()
      }:${
        ahora.getMinutes() < 10 ? `0${ahora.getMinutes()}` : ahora.getMinutes()
      } Hrs.`;

      const fechaCorta = `${ahora.getDate() < 10 ? `0${ahora.getDate()}` : ahora.getDate()
      }-${
        ahora.getMonth() < 10 ? `0${ahora.getMonth()}` : ahora.getMonth()
      }-${
        ahora.getFullYear()}`;
      const horaCorta = `${ahora.getHours() < 10 ? `0${ahora.getHours()}` : ahora.getHours()
      }:${
        ahora.getMinutes() < 10 ? `0${ahora.getMinutes()}` : ahora.getMinutes()}`;
      const horaCompleta = `${ahora.getHours() < 10 ? `0${ahora.getHours()}` : ahora.getHours()
      }:${
        ahora.getMinutes() < 10 ? `0${ahora.getMinutes()}` : ahora.getMinutes()
      }:${
        ahora.getSeconds() < 10 ? `0${ahora.getSeconds()}` : ahora.getSeconds()}`;
      linea = linea.replace('{fechaHoraCompleta}', fechaHoraCompleta);
      linea = linea.replace('{fechaCorta}', fechaCorta);
      linea = linea.replace('{horaCorta}', horaCorta);
      linea = linea.replace('{horaCompleta}', horaCompleta);
      return linea.trim();
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    configurations: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped>
.sign-image {
  width: 220px;
  height: 160px;
}

.preview-container {
  width: 450px;
  height: 150px;
  border: dotted gray 1px;
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  font-family: Roboto, sans-serif;
  color: black;
}

.preview-container div {
  padding: 0px;
}

.preview-container div.sign-container {
  width: 220px;
}

.preview-text-2 {
  font-size: 15px;
  margin-top: 5px;
  line-height: 1;
  width: 222px;
  float: right;
  white-space: pre-wrap;
  word-break: break-word
}

.preview-text-1 {
  font-size: 19px;
  margin-top: 48px;
  line-height: 1;
}

.signature-font {
  font-family: 'PWSignaturetwo';
  font-size: 42pt;
}

.sign-design {
  text-align: right;
  padding-top: 32px !important;
}
</style>
